import { sortBy } from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ISnListResponse, ISnListQueryParameters } from '@lib/api';
import { FsPolicyGroup } from 'libs/policy-groups/src/lib/models/policy-group';

@Injectable({ providedIn: 'root' })
export class SnGroupsAPI {
  constructor(private readonly _httpClient: HttpClient) {}

  public getGroupList(params?: ISnListQueryParameters): Observable<ISnListResponse<FsPolicyGroup>> {
    params.pageSize = 'all';
    return this._httpClient.get('/api/groups/', { params }).pipe(
      map((response: any) => ({
        count: response.count,
        totalPages: response.totalPages,
        results: sortBy(
          response.results.map((r) => {
            const group = new FsPolicyGroup(r);
            group.disabled = group.isExternallyManaged;
            return group;
          }),
          (i) => i.displayName,
        ),
      })),
    );
  }
}
